import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GET_CORE_KITS_FETCH_KEY } from "@/shared/core-product-kits/useCases/useGetKits";
import { Kit } from "@/shared/core-product-kits/types/Kit";

export interface CreateProductKit {
  name: string;
  products: {
    id: string;
    quantity: number | string;
  }[];
}

export const createProductKit = async (
  productKit: CreateProductKit,
): Promise<Kit> => {
  const response = await fetcher.post(`${API.GESLUB}/kit`, productKit);
  return response.data;
};

export const useCreateProductKit = () => {
  const queryClient = useQueryClient();

  return useMutation<Kit, Error, CreateProductKit>({
    mutationFn: createProductKit,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [GET_CORE_KITS_FETCH_KEY],
      });
    },
    onError: (error) => {
      console.error("Error al crear el kit y los productos:", error);
    },
  });
};
